import { FC } from 'react';

import { RemountableErrorBoundary } from 'modules/error';
import { SEGMENTATION_RUM_ATTRIBUTES } from '../../constants';
import { ErrorMessage } from './ErrorMessage';
import { useTranslation } from '../../hooks';

export const SegmentationQueryBuilderErrorBoundary: FC<
  React.PropsWithChildren<unknown> & { isSection?: boolean }
> = ({ children, isSection = false }) => {
  const { t } = useTranslation();

  return (
    <RemountableErrorBoundary
      errorMarkup={() => (
        <ErrorMessage
          isSection={isSection}
          title={t('errorBoundary.title')}
          description={t('errorBoundary.subtitle')}
        />
      )}
      {...SEGMENTATION_RUM_ATTRIBUTES}
    >
      {children}
    </RemountableErrorBoundary>
  );
};
